import api from './api';
import { EmergencyInfo } from '../types';

export const emergencyService = {
  async getEmergencyInfo(password: string): Promise<EmergencyInfo> {
    const response = await api.post<EmergencyInfo>('/emergency-info/get', {
      password,
    });
    return response.data;
  },

  async createEmergencyInfo(data: EmergencyInfo, password: string): Promise<EmergencyInfo> {
    const response = await api.post<EmergencyInfo>('/emergency-info/', {
      ...data,
      password,
    });
    return response.data;
  },

  async updateEmergencyInfo(data: EmergencyInfo, password: string): Promise<EmergencyInfo> {
    const response = await api.put<EmergencyInfo>('/emergency-info/', {
      ...data,
      password,
    });
    return response.data;
  },

  async deleteEmergencyInfo(password: string): Promise<void> {
    await api.delete('/emergency-info/', {
      data: { password },
    });
  },
}; 